import React from 'react';
import { Badge, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

type Props = {
    label: string;
    summary: string;
    placeholder: string;
    count?: number;
    onOpen: () => void;
};

const FilterRow: React.FC<Props> = ({ label, summary, placeholder, count = 0, onOpen }) => (
    <UnstyledButton className="bd-fp-row" data-active={summary ? true : undefined} onClick={onOpen} aria-label={summary ? `${label}: ${summary}` : label}>
        <Text component="span" className="bd-fp-row-label">{label}</Text>
        <Text component="span" className="bd-fp-row-summary" title={summary || undefined}>{summary || placeholder}</Text>
        {count > 1 ? <Badge size="xs" circle variant="light" color="brand">{count}</Badge> : null}
        <IconChevronRight size={16} stroke={1.8} className="bd-fp-row-chevron" aria-hidden />
    </UnstyledButton>
);

export default FilterRow;
